/**
 * ar-article-toc.js
 * 本文セクション (.ar-article-body) 内の <h2> を抽出して、
 * .ar-article-toc 内の <ol data-ar-article-toc-list> に目次を注入する。
 *
 * 各 h2 に id を付与してアンカーリンク化（ヘッダー固定分のオフセット込みでスクロール）。
 */
(function () {
  'use strict';

  function slugify(text) {
    return String(text)
      .trim()
      .toLowerCase()
      .replace(/[\s　]+/g, '-')
      .replace(/[^\w\-぀-ヿ一-鿿]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getHeaderOffset() {
    var header = document.querySelector('.shopify-section-group-header-group, .ar-header, header');
    return header ? header.getBoundingClientRect().height + 16 : 80;
  }

  function smoothScrollTo(el) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function build() {
    var tocSections = document.querySelectorAll('.ar-article-toc[data-ar-article-toc]');
    if (!tocSections.length) return;

    var body = document.querySelector('.ar-article-body[data-ar-article-body]');
    if (!body) {
      tocSections.forEach(function (sec) {
        var empty = sec.querySelector('[data-ar-article-toc-empty]');
        if (empty) empty.hidden = false;
      });
      return;
    }

    var headings = body.querySelectorAll('h2');
    if (!headings.length) {
      tocSections.forEach(function (sec) {
        var empty = sec.querySelector('[data-ar-article-toc-empty]');
        if (empty) empty.hidden = false;
      });
      return;
    }

    var items = [];
    var usedIds = {};
    headings.forEach(function (h, i) {
      var text = h.textContent.replace(/\s+/g, ' ').trim();
      if (!text) return;
      var id = h.id || slugify(text) || ('toc-' + (i + 1));
      while (usedIds[id]) {
        id = id + '-' + (i + 1);
      }
      usedIds[id] = true;
      h.id = id;
      items.push({ id: id, text: text });
    });

    if (!items.length) {
      tocSections.forEach(function (sec) {
        var empty = sec.querySelector('[data-ar-article-toc-empty]');
        if (empty) empty.hidden = false;
      });
      return;
    }

    tocSections.forEach(function (sec) {
      var list = sec.querySelector('[data-ar-article-toc-list]');
      if (!list) return;
      list.innerHTML = '';

      items.forEach(function (item, idx) {
        var li = document.createElement('li');
        li.className = 'ar-article-toc__item';

        var a = document.createElement('a');
        a.className = 'ar-article-toc__link';
        a.href = '#' + item.id;

        var num = document.createElement('span');
        num.className = 'ar-article-toc__number';
        num.textContent = (idx + 1) + '.';

        var label = document.createElement('span');
        label.className = 'ar-article-toc__label';
        label.textContent = item.text;

        var arrow = document.createElement('span');
        arrow.className = 'ar-article-toc__arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '›';

        a.appendChild(num);
        a.appendChild(label);
        a.appendChild(arrow);
        li.appendChild(a);
        list.appendChild(li);

        a.addEventListener('click', function (e) {
          var target = document.getElementById(item.id);
          if (!target) return;
          e.preventDefault();
          smoothScrollTo(target);
          if (history.replaceState) history.replaceState(null, '', '#' + item.id);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
